import { InputAdornment } from "@material-ui/core";
import { get } from "lodash";
import React, { Fragment } from "react";
import {
	LinearProgress,
	NumberInput,
	required,
	useInput,
	useReference,
} from "react-admin";
import { useInputStyles } from "../../components/forms/useStyles";

const PointsRankingPosition = ({ ...props }) => {
	const classes = useInputStyles();
	const { input: contestInput } = useInput("contest_id");
	const contestId = get(contestInput, "value.contest_id", 1);
	const { loading, referenceRecord } = useReference({
		id: contestId,
		reference: "contests",
	});

	if (loading) {
		return <LinearProgress />;
	}

	const contestType = get(referenceRecord, "type");
	if (!contestType) {
		return null;
	}

	return (
		<Fragment>
			{contestType === "points" ? (
				<Fragment>
					<div>
						<NumberInput
							{...props}
							className={classes.input}
							source="points_from"
							validate={required()}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">pt</InputAdornment>
								),
							}}
						/>
					</div>
					<div>
						<NumberInput
							{...props}
							className={classes.input}
							source="points_to"
							validate={required()}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">pt</InputAdornment>
								),
							}}
						/>
					</div>
				</Fragment>
			) : (
				<div>
					<NumberInput
						{...props}
						className={classes.input}
						source="ranking_position"
						validate={required()}
						InputProps={{
							endAdornment: <InputAdornment position="end">°</InputAdornment>,
						}}
					/>
				</div>
			)}
		</Fragment>
	);
};

export default PointsRankingPosition;
